webpackJsonp([212839066777427],{

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blog-hero.597073e7.svg";

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blogHero = __webpack_require__(457);
	
	var _blogHero2 = _interopRequireDefault(_blogHero);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'w-100 w-50-ns center' },
	    _react2.default.createElement(
	      'div',
	      { className: 'f2 tc' },
	      'Speer Blog'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'f4 w-80 mt3 tc center lighter-gray' },
	      'Stories from your buying assistants.'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'center tc' },
	      _react2.default.createElement('img', { src: _blogHero2.default, className: 'h5 mt4' })
	    )
	  );
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(48);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PostLink = function PostLink(_ref) {
	  var _ref$post = _ref.post,
	      _ref$post$frontmatter = _ref$post.frontmatter,
	      title = _ref$post$frontmatter.title,
	      path = _ref$post$frontmatter.path,
	      date = _ref$post$frontmatter.date,
	      tags = _ref$post$frontmatter.tags,
	      excerpt = _ref$post.excerpt;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: path },
	    _react2.default.createElement(
	      'div',
	      { className: 'pa3 br2 ba b--lightest-gray dim pointer' },
	      _react2.default.createElement(
	        'div',
	        { className: 'f3' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'black-40' },
	        date
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mt3' },
	        excerpt
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mt3' },
	        tags && tags.map(function (t, i) {
	          return _react2.default.createElement(
	            'span',
	            { key: i, className: 'f7 lighter-gray ttu b mr3' },
	            t
	          );
	        })
	      )
	    )
	  );
	};
	
	exports.default = PostLink;
	module.exports = exports['default'];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tags = function Tags(_ref) {
	  var tagList = _ref.tagList;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    tagList.map(function (t) {
	      return _react2.default.createElement(
	        "div",
	        { className: "light-blue b dib mr4 pointer dim" },
	        "#" + t
	      );
	    })
	  );
	};
	
	exports.default = Tags;
	module.exports = exports["default"];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hero = __webpack_require__(211);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _tags = __webpack_require__(213);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _postLink = __webpack_require__(212);
	
	var _postLink2 = _interopRequireDefault(_postLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(_ref) {
	  var edges = _ref.data.allMarkdownRemark.edges;
	
	  var tagList = edges.reduce(function (accumulator, e) {
	    return [].concat(accumulator, e.node.frontmatter.tags);
	  }, []).filter(function (t) {
	    return t;
	  });
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_hero2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'w-90 w-50-ns center mt4 pt2 bt b--lightest-gray' },
	      _react2.default.createElement(
	        'div',
	        { className: 'bb b--lightest-gray pb2 mb4' },
	        _react2.default.createElement(_tags2.default, { tagList: tagList })
	      ),
	      edges.filter(function (edge) {
	        return !edge.node.frontmatter.isFixedPage;
	      }).map(function (edge) {
	        return _react2.default.createElement(_postLink2.default, { key: edge.node.id, post: edge.node });
	      })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Blog;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-efcab4efdf6eecc7824b.js